const Gates = {
  BUSINESS_UNITS_ALL_SOURCE_APPS: 'AutomationManagementBusinessUnitAllSourceApps',
  REVISION_ROLLUP_MIGRATION: 'Workflows:RevisionRollupMigration',
  ILS_GOALS_MIGRATION: 'workflows:fe:ilsGoalsMigration',
  WORKFLOWS_TEMPLATE_SUGGESTIONS: 'workflows:templateSuggestions'
};
export default Gates;